:host {
  --Tooltip__tooltip--min-width: 50px;
  --Tooltip__tooltip--max-width: 50vw;
  --Tooltip__tooltip--min-height: 1em;
  --Tooltip__tooltip--max-height: 90vmax;
  --Tooltip__arrow--size: 10px;
  --Tooltip__tooltip--border-radius: var(--Common--border-radius);
  --Tooltip__tooltip--border-radius--small: calc(var(--Tooltip__tooltip--border-radius) / 2);
  --Tooltip__tooltip--border: none;
  --Tooltip__tooltip--box-shadow: none;
  --Tooltip__tooltip--padding: 0.375rem 0.5rem;
  --Tooltip__tooltip--outer-padding: 0.3125rem;
  --Tooltip__tooltip--text-color: var(--theme-inverted-primary-text);
  --Tooltip__tooltip--background-color: var(--theme-inverted-background);
  --Tooltip__tooltip--font-size: 11px;
  --Tooltip__tooltip--line-height: var(--default-line-height);
  --Tooltip__tooltip--text-align: center;
  display: none;
  position: absolute;
}
:host([aria-hidden='false']) {
  display: initial;
}

:host([type='popover']) {
  --popover-background: var(--theme-primary-background);
  --Tooltip__tooltip--border: none;
  --Tooltip__tooltip--box-shadow: var(--theme-shadow);
  --Tooltip__tooltip--text-color: var(--theme-primary-text);
  --Tooltip__tooltip--background-color: var(--popover-background);
  --Tooltip__tooltip--font-size: 13px;
  --Tooltip__tooltip--line-height: var(--default-line-height);
  --Tooltip__tooltip--text-align: left;
}

:host([arrow='false']) #tooltip-arrow,
:host([arrow='false']) #tooltip-arrow {
  display: none;
}

:host([aria-disabled]) slot[name='trigger']::slotted(*),
:host([aria-disabled]) .default-trigger {
  cursor: not-allowed;
}

button {
  border: none;
  background: transparent;
  border-radius: var(--Common--border-radius);
  outline: none;
  list-style-type: none;
}

#tooltip {
  position: absolute;
  padding: var(--Tooltip__tooltip--outer-padding);
  display: none;
  z-index: 1000;
}

#tooltip__inner {
  background-color: var(--Tooltip__tooltip--background-color);
  box-shadow: var(--Tooltip__tooltip--box-shadow);
  border-radius: var(--Tooltip__tooltip--border-radius);
  font-weight: 400;
}

#tooltip__content {
  text-align: var(--Tooltip__tooltip--text-align);
  color: var(--Tooltip__tooltip--text-color);
  min-width: var(--Tooltip__tooltip--min-width);
  max-width: var(--Tooltip__tooltip--max-width);
  min-height: var(--Tooltip__tooltip--min-height);
  max-height: var(--Tooltip__tooltip--max-height);
  padding: var(--Tooltip__tooltip--padding);
  border: var(--Tooltip__tooltip--border);
  font-size: var(--Tooltip__tooltip--font-size);
  line-height: var(--Tooltip__tooltip--line-height);
}

#tooltip-arrow {
  position: absolute;
  width: var(--Tooltip__arrow--size);
  height: calc(var(--Tooltip__arrow--size) / 2);
  overflow: hidden;
}

#tooltip-arrow:before {
  content: '';
  position: absolute;
  width: var(--Tooltip__arrow--size);
  height: var(--Tooltip__arrow--size);
  background-color: var(--Tooltip__tooltip--background-color);
  box-shadow: var(--Tooltip__tooltip--box-shadow);
  transform: rotate(45deg) scale(0.7);
}

:host([rendered-placement^='right']) #tooltip-arrow,
:host([rendered-placement^='left']) #tooltip-arrow {
  height: var(--Tooltip__arrow--size);
  width: calc(var(--Tooltip__arrow--size) / 2);
}

:host([rendered-placement^='top']) #tooltip-arrow:before {
  bottom: 0;
  left: 0;
}

:host([rendered-placement^='bottom']) #tooltip-arrow:before {
  top: 0;
  left: 0;
}

:host([rendered-placement^='left']) #tooltip-arrow:before {
  right: 0;
  top: 0;
}

:host([rendered-placement^='right']) #tooltip-arrow:before {
  left: 0;
  top: 0;
}

:host([rendered-placement='top-start']) #tooltip {
  border-bottom-left-radius: var(--Tooltip__tooltip--border-radius--small);
}

:host([rendered-placement='top-end']) #tooltip {
  border-bottom-right-radius: var(--Tooltip__tooltip--border-radius--small);
}

:host([rendered-placement='bottom-start']) #tooltip {
  border-top-left-radius: var(--Tooltip__tooltip--border-radius--small);
}

:host([rendered-placement='bottom-end']) #tooltip {
  border-top-right-radius: var(--Tooltip__tooltip--border-radius--small);
}

:host([rendered-placement='left-start']) #tooltip {
  border-top-right-radius: var(--Tooltip__tooltip--border-radius--small);
}

:host([rendered-placement='left-end']) #tooltip {
  border-bottom-right-radius: var(--Tooltip__tooltip--border-radius--small);
}

:host([rendered-placement='right-start']) #tooltip {
  border-top-left-radius: var(--Tooltip__tooltip--border-radius--small);
}

:host([rendered-placement='right-end']) #tooltip {
  border-bottom-left-radius: var(--Tooltip__tooltip--border-radius--small);
}
